export default "__VITE_ASSET__6Y331rOV__"